import React, { useState } from "react";
import TextField from "../../../components/formcomponents/TextField";
import TextArea from "../../../components/formcomponents/TextArea";
import { useDispatch } from "react-redux";
import { updateCollaboration } from "../../../redux/actions/action";
//
const EditCollaboration = ({ event, onClose }) => {
  const [formData, setFormData] = useState({
    ...event,
    // startDate: event.startDate || "",
    // endDate: event.endDate || "",
    uploadPhoto: null,
    projectDescription: event.projectDescription || "",
    startDate: event.startDate ? new Date(event.startDate).toLocaleDateString('en-CA') : "",
    endDate: event.endDate ? new Date(event.endDate).toLocaleDateString('en-CA') : "",
  });

  const [errors, setErrors] = useState({
    projectName: "",
    projectDescription: "",
    organizationName: "",
    startDate: "",
    endDate: "",
  });

  const dispatch = useDispatch();
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    validateField(name, value);
  };

  const validateField = (name, value) => {
    let error = "";
    const today = new Date();

    switch (name) {
      case "projectName":
      case "organizationName":
        if (!/^[A-Za-z\s]+$/.test(value)) {
          error = `${name === "projectName" ? "Project Name" : "Organization Name"} must contain only alphabets.`;
        }
        break;
      case "teamSize":
        if (!/^[0-9]+$/.test(value)) {
          error = "Team Size must contain only numbers.";
        }
        break;
      case "teamMembers":
        const membersArray = value.split(",").map((m) => m.trim()).filter((m) => m);
        const size = parseInt(formData.teamSize, 10);
        if (formData.teamSize && membersArray.length !== size) {
          error = `Team members count (${membersArray.length}) should match team size (${size}).`;
        }
        break;
      case "startDate":
        if (new Date(value) < today.setHours(0, 0, 0, 0)) {
          error = "Start date must be today or in the future.";
        }
        break;
      case "endDate":
        if (new Date(value) <= new Date(formData.startDate)) {
          error = "End date must be greater than the start date.";
        }
        break;
      default:
        break;
    }

    setErrors((prev) => ({ ...prev, [name]: error }));
  };


  const handleSubmit = (e) => {
    e.preventDefault();

    const hasErrors = Object.values(errors).some((error) => error);
    if (hasErrors) return;

    dispatch(updateCollaboration(formData));
    onClose();
  };

  
  // const imageName = formData.uploadPhoto ? formData.uploadPhoto.name : "";

  return (
    <div className="relative bg-color w-screen-full mr-20 md:ml-[-500px] lg:ml-[300px] mr-16  mb-2 rounded-4xl border-4 border-white popup-content grid rounded-3xl border-4 border-white border-solid justify-items-start">
      {/* <div className="self-stretch flex flex-col bg-color items-start justify-start max-w-full text-start text-xl text-black font-poppins rounded-3xl border-4 border-white border-solid "> */}

      <form
        onSubmit={handleSubmit}
        className="w-[670px] mx-0 mt-4 m-0 justify-center md:mx-0 md:px-3 md:mt-8 lg:mx-0 lg:mt-5 lg:justify-center md:pt-4 lg:pr-24"
      >

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6 ">

          <TextField
            label="Project Name*"
            name="projectName"
            type="text"
            value={formData.projectName}
            onChange={handleChange}
            placeholder="Enter Project Name"
            required
            className="w-full h-[45px]"
          />
          {errors.projectName && <p className="text-red-500 text-sm">{errors.projectName}</p>}

          <TextField
            label="Organization Name*"
            name="organizationName"
            type="text"
            value={formData.organizationName}
            onChange={handleChange}
            placeholder="Enter Organization Name"
            required
            className="w-full h-[45px]"
          />
          {errors.organizationName && (
            <p className="text-red-500 text-sm">{errors.organizationName}</p>
          )}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          <div>
            <label className="block mb-2 font-poppins font-bold text-white">Category*</label>
            <select
              className="w-full h-[45px] border border-gray-300 rounded-md px-3"
              name="category"
              value={formData.category}
              onChange={handleChange}
              required
            >
              <option value="">Select Category</option>
              <option value="Institutions">Institutions</option>
              <option value="Industry Partners">Industry Partners</option>
              <option value="Agencies">Agencies</option>
              <option value="FundingAgencies">Funding Agencies</option>
              <option value="Government Organization">Government Organizations</option>
              <option value="NGO">NGO</option>
            </select>
          </div>
          <div>
            <label className="block mb-2 font-poppins font-bold text-white">
              Research Area*
            </label>
            <select
              className="w-full h-[45px] border border-gray-300 rounded-md px-3"
              name="researchArea"
              value={formData.researchArea}
              onChange={handleChange}
              required
            >
              <option value="">Select Research Area</option>
              <option value="Education">Education</option>
              <option value="HealthCare">HealthCare</option>
              <option value="Logistics">Logistics</option>
              <option value="Agriculture">Agriculture</option>
              <option value="AnimalHusbandry">Animal Husbandry</option>
              <option value="InformationTechnology">Information Technology</option>
              <option value="Insurance">Insurance</option>

            </select>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          <TextField
            label="Start Date*"
            name="startDate"
            type="date"
            value={formData.startDate}
            onChange={handleChange}
            required
            className="w-full h-[45px]"
          />
          <TextField
            label="End Date*"
            name="endDate"
            type="date"
            value={formData.endDate}
            onChange={handleChange}
            required
            className="w-full h-[45px]"
          />
          {errors.startDate && <p className="text-red-500 text-sm">{errors.startDate}</p>}
          {errors.endDate && <p className="text-red-500 text-sm">{errors.endDate}</p>}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          <TextField
            label="Team Size*"
            name="teamSize"
            type="number"
            value={formData.teamSize}
            onChange={handleChange}
            placeholder="Enter Team Size"
            required
            className="w-full h-[45px]"
          />
          {errors.teamSize && <p className="text-red-500 text-sm">{errors.teamSize}</p>}
          <TextField
            label="Team Members*"
            name="teamMembers"
            type="text"
            value={formData.teamMembers}
            onChange={handleChange}
            placeholder="Enter Team Members"
            required
            className="w-full h-[45px]"
          />
          {errors.teamSize && <p className="text-red-500 text-sm">{errors.teamSize}</p>}

        </div>
        <TextArea
          label="Project Description*"
          name="projectDescription"
          type="text"
          value={formData.projectDescription}
          onChange={handleChange}
          placeholder="Enter ProjectDescription "
          required
          className="w-full h-[80px]"
        />
        <div className="flex justify-center mt-6 mb-4">
          <button
            type="button"
            onClick={onClose}
            className="bg-black text-white py-2 px-6 rounded-lg mr-4"
          >
            Cancel
          </button>
          <button type="submit" className="bg-black text-white py-2 px-6 rounded-lg">
            Save
          </button>
        </div>
      </form>
    </div>

  );
};

export default EditCollaboration;